import { AuthServiceInterface } from '@/services/interface/AuthService.js'
import { BackendAuthService } from '@/services/impl/BackendAuthService.js'
import { DemoAuthService } from '@/services/impl/DemoAuthService.js'

let service = BackendAuthService

export function setupBackendAuthService () {
  service = BackendAuthService
}

export function setupDemoAuthService () {
  service = DemoAuthService
}

export class AuthService extends AuthServiceInterface {
  static async authenticate (login, password) {
    return service.authenticate(login, password)
  }

  static async userInfo () {
    return service.userInfo()
  }

  static async logout () {
    return service.logout()
  }
}
